import { z } from "zod";

const ACCEPTED_IMAGE_TYPES = ["jpeg", "jpg", "png", "webp"];
const ImgSchema = z.object({
  fileName: z.string(),
  name: z.string(),
  fileSize: z.number(),
  size: z.number(),
  key: z.string(),
});
export const IMG_MAX_LIMIT = 1;

export const sliderSchema = z.object({
  image: z
    .array(ImgSchema, { required_error: "L'image est obligatoire" })
    .max(IMG_MAX_LIMIT, {
      message: "Vous ne pouvez ajouter qu'une seule image.",
    })
    .min(1, { message: "Au moins une image doit être ajoutée." })
    .refine(
      (images) => {
        const invalidImages = images.filter((img) => {
          const fileExtension = img.fileName.split(".").pop()?.toLowerCase();
          return fileExtension && !ACCEPTED_IMAGE_TYPES.includes(fileExtension);
        });
        return invalidImages.length === 0;
      },
      {
        message: "Le type de fichier de l'image n'est pas pris en charge.",
      }
    ),
});

export type SliderFormValues = z.infer<typeof sliderSchema>;

export const updatesliderSchema = z
  .object({
    image: z
      .array(ImgSchema)
      .max(IMG_MAX_LIMIT, {
        message: "Vous ne pouvez ajouter qu'une seule image.",
      })
      .min(1, { message: "Au moins une image doit être ajoutée." })
      .refine(
        (images) => {
          const invalidImages = images.filter((img) => {
            const fileExtension = img.fileName.split(".").pop()?.toLowerCase();
            return (
              fileExtension && !ACCEPTED_IMAGE_TYPES.includes(fileExtension)
            );
          });
          return invalidImages.length === 0;
        },
        {
          message: "Le type de fichier de l'image n'est pas pris en charge.",
        }
      ),
  })
  .partial();

export type UpdateSliderFormValues = z.infer<typeof updatesliderSchema>;
